import { Navigate } from "react-router-dom";
import Constants from "../../utils/Constants";
import { useProtectedRouteLogin } from "./useProtectedRouteLogin";
import useProtectedRouteAuthCd from "./useProtectedRouteAuthcd";
import useProtectedRouteMaxage from "./useProtectedMaxage";
import { FC } from "react";
import { ThemeProvider } from "@mui/material";
import { ResultResponse } from "../common/dialog/ResultDialog";

type Props = {
  authcd: any;
  defaultFunction: () => void;
  overrideFunction: (response: ResultResponse) => void;
  children: React.ReactNode;
}

// NOTE:現在はボタンに割り込み処理を付ける想定、処理を汎用ダイアログに移行
export const ProtectedApiAuth: FC<Props> = ({
  authcd,
  defaultFunction,
  overrideFunction,
  children
}) => {

  const forbiddenResponse = {
    status: "NG",
    code: "",
    displayMessage: "この操作は許可されていません。",
    result: [],
    errorMessages: [],
  } as ResultResponse;

  // ログインチェック
  let auth = useProtectedRouteLogin();

  // 権限チェック
  const role = useProtectedRouteAuthCd(authcd);

  // 日付更新
  useProtectedRouteMaxage();

  // 認証情報NG
  if (!auth) {
    return <Navigate to={Constants.NAVI_LOGIN} />
  }

  // 権限に応じたイベントの選択
  const overrideTheme = Constants.DEFAULT_THEME && {
    components:{
      MuiButton: {
        defaultProps: {
          onClick: () => {
            role ? defaultFunction() : overrideFunction(forbiddenResponse);
          },
        },
      },
      MuiIconButton: {
        defaultProps: {
          onClick: () => {
            role ? defaultFunction() : overrideFunction(forbiddenResponse);
          }
        }
      },
    },
  };

  // 権限に応じた遷移
  return (
      <ThemeProvider theme={overrideTheme}>
        {children}
      </ThemeProvider>
    );

}